import { useContext } from "react";
import { SDSThemeContext } from "../SDSThemeProvider";
import { lodestarTheme } from "../lodestarTheme";
export const useTheme = () => {
  const theme = useContext(SDSThemeContext);
  const noTheme = Object.keys(theme).length === 0;
  // if the theme is empty, return the default lodestar theme
  if (noTheme && process.env.NODE_ENV !== "production") {
    console.warn("useTheme: no SDSThemeProvider context found, defaulting to lodestar-light.");
  }
  return noTheme ? lodestarTheme : theme;
};
//# sourceMappingURL=useTheme.js.map